import { colorSchemeTokens } from '@sixui/ui/themes/base/colorScheme.stylex';
import stylex from '@stylexjs/stylex';

import { Footer } from '~/components/organisms/Footer';
import { TopLoadingBarWithState } from '~/components/organisms/TopLoadingBar';
import { PwaReloadPrompt } from '~/components/utils/PwaReloadPrompt';
import { ITimeUnit } from '~/helpers/types';
import { useScrollToTop } from '~/hooks/useScrollToTop';

export type IRootTemplateProps = {
  children: React.ReactNode;
};

const styles = stylex.create({
  main: {
    minHeight: '100dvh',
    backgroundColor: colorSchemeTokens.surfaceContainerLow,
  },
  footer: {
    borderTopColor: colorSchemeTokens.outlineVariant,
    borderTopWidth: 1,
    borderTopStyle: 'solid',
  },
});

export const RootTemplate: React.FC<IRootTemplateProps> = (props) => {
  const { children } = props;
  useScrollToTop();

  return (
    <>
      <TopLoadingBarWithState
        showAfterMinLoadingTime={300 * ITimeUnit.MILLISECOND}
      />
      <PwaReloadPrompt />
      <div id="markdown-editor__image-dialog-container" />

      <div {...stylex.props(styles.main)}>{children}</div>
      <Footer sx={styles.footer} />
    </>
  );
};
